import React, { useState, useCallback } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { CircularProgress, TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'

import { getListBatch } from 'services/apiMotorBgc'
import { formatDate } from 'utils/masks'

const InputAutocomplete = ({ onSelect }) => {
  const userId = useSelector((state) => state.auth.sub)
  const apiKey = useSelector((state) => state.auth.api_key)
  const panelEnv = useSelector((state) => state.auth.panelEnv)

  const [batchList, setBatchList] = useState([])
  const [loading, setLoading] = useState(false)
  const [inputErrorMsg, setInputErrorMsg] = useState(null)

  const listBatches = async (options = {}) => {
    setLoading(true)

    let res = null
    try {
      res = await getListBatch(
        apiKey,
        userId,
        panelEnv,
        {
          description: options.description,
          page: _.has(options, 'page') ? options.page : 1,
        },
      )
    } catch (err) {
      const messageError = _.get(err, 'response.data.msg_errors.0.msg') || 'Erro ao listar lotes'
      setInputErrorMsg(messageError)
      setBatchList([])
      setLoading(false)
      return
    }

    setInputErrorMsg(null)
    setBatchList(res.data)
    setLoading(false)
  }

  const handleChange = (_e, val) => {
    if (onSelect) onSelect(val)
  }

  const handleChangeInput = (_e, val) => {
    const newVal = _.trim(val)
    if (!_.isEmpty(newVal) && newVal.length < 3) return

    const options = {}
    if (!_.isEmpty(newVal)) options.description = newVal

    listBatches(options)
  }

  const handleChangeInputMemoized = useCallback(
    _.debounce(handleChangeInput, 500, {
      'leading': false,
      'trailing': true,
    }),
    [],
  )

  const handleOpen = () => {
    listBatches()
  }

  const renderOption = (option) => {
    return (
      <div style={{ display: 'flex', flexGrow: 1, justifyContent: 'space-around' }}>
        <span>{option.description}</span>
        <span>{formatDate(option.created_at)}</span>
      </div>
    )
  }

  const renderInput = (params) => (
    <TextField
      {...params}
      label="Escolha um Lote"
      helperText={inputErrorMsg}
      error={!_.isEmpty(inputErrorMsg)}
      InputProps={{
        ...params.InputProps,
        endAdornment: (
          <React.Fragment>
            {loading ? <CircularProgress color="inherit" size={20} /> : null}
            {params.InputProps.endAdornment}
          </React.Fragment>
        ),
      }}
    />
  )

  return (
    <Autocomplete
      fullWidth={true}
      getOptionLabel={option => option.description}
      getOptionSelected={(option, selected) => option.batch_id === selected.batch_id}
      loading={loading}
      onChange={handleChange}
      onInputChange={handleChangeInputMemoized}
      onOpen={handleOpen}
      options={batchList}
      renderOption={renderOption}
      renderInput={renderInput}
    />
  )
}

InputAutocomplete.defaultProps = {
  onSelect: null,
}

InputAutocomplete.propTypes = {
  onSelect: PropTypes.func,
}

export default InputAutocomplete
